<template>
  <b-modal
    :id="id"
    title=""
    size="lg"
    ok-only
    header-bg-variant="lisaweb"
    @hidden="hideModal()"
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <span>{{ title }}</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>

    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div
          class="channel-selector mb-3 mt-3"
          role="group"
          aria-label="Canale di invio"
        >
          <b-button
            v-for="option in channels"
            :key="option.value"
            class="btn--transparent btn--smaller"
            type="button"
            size="sm"
            :pressed="channel === option.value"
            :disabled="!option.enabled"
            @click="selectChannel(option.value)"
          >
            <b-icon :icon="option.icon" class="mr-1" />{{ option.label }}
          </b-button>
        </div>
        <template v-if="currentItems.length">
          <p class="modal-desc">
            {{
              channel === "email"
                ? "Seleziona uno dei modelli e-mail per procedere all'invio."
                : "Seleziona uno dei modelli SMS per procedere all'invio."
            }}
          </p>
          <b-form-radio-group
            id="radiosSelezionaModello"
            v-model="selected"
            name="radio-options-seleziona-modello-email"
          >
            <saved-email-models
              v-for="(model, index) in currentItems"
              :key="index"
              :model="model"
            ></saved-email-models>
          </b-form-radio-group>
        </template>
        <template v-else>
          <p class="modal-desc mt-3">
            {{
              channel === "email"
                ? "Non ci sono modelli e-mail salvati."
                : "Non ci sono modelli SMS salvati."
            }}
          </p>
        </template>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
    <template #modal-footer>
      <b-btn
        variant="lisaweb"
        class=""
        size="sm"
        :disabled="selected === null"
        @click="onSend"
      >
        {{ sendLabel }}
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import SavedEmailModels from "@/components/analysis/components/savedEmailModels.vue";
import { RepositoryFactory } from "@/repositories/lisacomunica/RepositoryFactory";
import ConfirmModalMixin from "@/mixins/ConfirmModalMixin";
export default {
  mixins: [ConfirmModalMixin],
  data() {
    return {
      id: "modalScegliModelliEmail",
      repository: "analysis",
      resource: "analysis",
      isLoading: true,
      tableRef: {
        email: "emailTableRef",
      },
      selected: null,
      channel: "email",
      emailItems: [],
      smsItems: [],
    };
  },
  props: {
    hasEmail: {
      type: Boolean,
      default: false,
    },
    hasSms: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Prepara Spedizioni",
    },
    sendLabel: {
      type: String,
      default: "Invia Spedizioni",
    },
    // Quando valorizzato, il messaggio di conferma usa il conteggio dei
    // destinatari invece del riferimento alle icone di recapito delle righe,
    // che esistono solo nelle tabelle di Analisi.
    recipientsCount: {
      type: Number,
      default: null,
    },
  },
  computed: {
    rep() {
      return this.repository;
    },
    currentItems() {
      return this.channel === "email" ? this.emailItems : this.smsItems;
    },
    channels() {
      return [
        {
          value: "email",
          label: "Email",
          icon: "envelope",
          enabled: this.hasEmail,
        },
        { value: "sms", label: "SMS", icon: "phone", enabled: this.hasSms },
      ];
    },
  },
  methods: {
    htmlToVNode(html) {
      return [this.$createElement("div", { domProps: { innerHTML: html } })];
    },
    onModalShow(bvEvent, modalId) {
      if (modalId !== this.id) return;
      this.selected = null;
      this.channel = this.hasEmail ? "email" : "sms";
      this.emailItems = [];
      this.smsItems = [];
      this.loadModels();
    },
    selectChannel(value) {
      // The radio group only fired @change on an actual change: keep that, so
      // re-clicking the current channel does not refetch the models.
      if (this.channel === value) return;
      this.channel = value;
      this.onChannelChange();
    },
    onChannelChange() {
      this.selected = null;
      this.loadModels();
    },
    onSend() {
      const isEmail = this.channel === "email";
      if (this.recipientsCount !== null) {
        this.showConfirm({
          yesCallback: this.send,
          noCallback: null,
          title: "Conferma operazione",
          message:
            this.recipientsCount === 1
              ? `Confermi l'invio della comunicazione ${
                  isEmail ? "e-mail" : "SMS"
                } a 1 destinatario selezionato?`
              : `Confermi l'invio della comunicazione ${
                  isEmail ? "e-mail" : "SMS"
                } ai ${this.recipientsCount} destinatari selezionati?`,
          yesLabel: "Invia",
          noLabel: "Annulla",
        });
        return;
      }
      const iconSvg = isEmail
        ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 473.895 319.292" width="18"><title>Indirizzo e-mail presente</title><path d="M28.8 0h389.26c15.73 0 28.52 12.88 28.5 28.53l-.1 95.75c-7.58-2.84-15.46-5.04-23.59-6.55l.07-77.07-125.82 98.89 9.17 8.99c-3.04 2.56-5.94 5.24-8.75 8.04l-.09.1c-3.27 3.27-6.37 6.72-9.32 10.29l-10.89-10.69-42.14 35.87c-4.49 3.77-11.46 4.22-16.5.11l-44.24-36.09L39.45 282.69h219.27c1.54 8.04 3.779 15.929 6.69 23.58l-236.92.02C12.74 306.29 0 293.42 0 277.76L.24 28.52C.27 12.84 13.05 0 28.8 0zm-5.19 261.9l130.45-122.08L23.82 41.69l-.21 220.21zM42.65 23.6l183.96 141.87L400.69 23.6H42.65zm399.06 141.917l-89.407 89.42-40.833-40.833-32.169 32.169 40.842 40.828-.038.038 32.169 32.153 121.605-121.606-32.169-32.169z" fill="#5bb55e"/></svg>`
        : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18"><title>Cellulare presente</title><path d="M5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5zm1 1h4a1 1 0 0 1 1 1v11H5V2a1 1 0 0 1 1-1zm2 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" fill="#5bb55e"/></svg>`;
      const channel_label = isEmail ? "e-mail" : "SMS";
      const msg = this.htmlToVNode(
        `<p style="display:flex;align-items:center;gap:8px;"><span>Confermi l'invio della comunicazione ${channel_label} ai destinatari selezionati che presentano la seguente icona?</span>${iconSvg}</p>`,
      );
      this.showConfirm({
        yesCallback: this.send,
        noCallback: null,
        title: "Conferma operazione",
        message: msg,
        yesLabel: "Invia",
        noLabel: "Annulla",
      });
    },
    send() {
      this.$bvModal.hide(this.id);
      this.$emit("sendProcedure", {
        channel: this.channel,
        template_id: this.selected,
      });
    },
    loadModels() {
      this.isLoading = true;
      const Repo = RepositoryFactory.get(
        this.channel === "email" ? "email" : "sms",
      );
      Repo.index()
        .then((response) => {
          const items = response.data.content;
          if (this.channel === "email") {
            this.emailItems = items;
          } else {
            this.smsItems = items;
          }
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    hideModal() {
      this.$bvModal.hide(this.id);
    },
  },
  components: { BaseIcon, SavedEmailModels },
  mounted() {
    this.$root.$on("bv::modal::show", this.onModalShow);
  },
  beforeDestroy() {
    // Pass the handler: a bare $off would drop every other bv::modal::show
    // listener registered on $root.
    this.$root.$off("bv::modal::show", this.onModalShow);
  },
};
</script>
<style lang="scss">
#modalScegliModelliEmail {
  .channel-selector {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--color-border);
    .btn {
      // No focus ring for pointer interactions (matches the filter buttons)...
      &:hover,
      &:active,
      &:focus:not(:focus-visible) {
        outline: none !important;
        box-shadow: none !important;
      }
      // ...but keep a clear, keyboard-only focus indicator for accessibility.
      &:focus-visible {
        outline: 2px solid var(--color-text) !important;
        outline-offset: 2px;
        box-shadow: none !important;
      }
      // The selected channel keeps the ring, like the "Selezione avanzata"
      // toggle. Declared last so hover/focus cannot clear it.
      &.active {
        box-shadow: 0 0 0 0.3rem var(--lisaweb-light) !important;
      }
    }
  }
  .modal-content {
    min-height: 350px;
    input[type="radio"] {
      cursor: pointer;
      + label {
        cursor: pointer;
      }
    }
  }
}
</style>
<style scoped>
#radiosSelezionaModello {
  max-height: 45vh;
  overflow-y: auto;
  padding: 0 0 60px;
}
</style>
